import GameOver from '../assets/proyects_img/GameOver/gameover.jpg';
import GameMatch from '../assets/proyects_img/GameMatch/GameMatch.png';

const projects = [
     {
          img: [GameOver],
          name: 'Game Over Wiki',
          technologys: 'JavaScript, React, Redux, NodeJs, Express, Sequelize, PostgreSQL',
          description:
               'This page was made with CSS (without extra libraries). The objective was to make a functional page which consumes information from an external API and in turn manages to save the video game created in the Database. Pagination and a series of filters that manage to interact with each other were added. The form used to create a custom video game is controlled by Javascript. Before submitting, all the required data is checked to make sure it is complete and has no errors. Also the page is fully responsive (you can see it from your mobile or tablet).',
          link: 'https://pi-videogames-cyan-five.vercel.app/',
          delay: 0,
     },
     {
          img: [GameMatch],
          name: 'Game Match',
          technologys:
               'JavaScript, React Native, Redux, NodeJs, Express, Sequelize, MongoDB, Socket.io',
          description:
               'The objective was to make a functional Mobile App where you can register, access and find your ideal game partner. Added a chat channel so you can talk to the person you matched with and coordinate when to play. You can also edit your profile, see the profile of other users, rate them according to your gaming experience with them and much more. If you want to see the rest of the functions then try it.',
          link: 'https://www.youtube.com/watch?v=bdFyQGHnN-E',
          delay: 200,
     },
];

export default projects;
